import { render } from "./BaseDialogColorPicker.vue?vue&type=template&id=6c64c6a2"
import script from "./BaseDialogColorPicker.vue?vue&type=script&lang=js"
export * from "./BaseDialogColorPicker.vue?vue&type=script&lang=js"

import "./BaseDialogColorPicker.vue?vue&type=style&index=0&id=6c64c6a2&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__